<mvms-rewards-list></mvms-rewards-list>
